angular.module("vgresiduos").controller("DisposalIntegrationCtrl", [
	"$rootScope",
	"$scope",
	"$q",
	"httpService",
	"mtrSystemService",
	"accountService",
	"$state",
	"$window",
	function ($rootScope, $scope, $q, httpService, mtrSystemService, accountService, $state, $window) {
		"use strict";

		$scope.labels = $rootScope.labels;

		$scope.exemptionMessages = [];

		$scope.goToMtrIntegrationConfig = function () {
			const url = $state.href("mtrIntegrationList", { tab: 1 });
			$window.open(url, "_blank");
		};

		this.$onInit = function () {
			if (!$scope.isCurrentStageReview() && !$scope.hasIntegrations() && $scope.canGenerateMtr()) {
				calculateSystemsToIntegrate().then(function (mtrSystemsToIntegrate) {
					$scope.ctrl.destinationModel.ExternalSystems = mtrSystemsToIntegrate;

					updateSlip();
					$rootScope.$broadcast(Vgr.constants.evtClientExternalSystemChanged, $scope.ctrl.destinationModel.Id);
				});
			}
		};

		function calculateSystemsToIntegrate() {
			const deferred = $q.defer();

			const destinatorCity = $scope.ctrl.readOnlyModel.Destinator.City;
			const dto = {
				organizationUnitId: accountService.getCurrentClient().id,
				destinatorStateId: destinatorCity ? destinatorCity.State.Id : null,
				residueIds: getDisposalResidueIds()
			};

			httpService.postDTOToServiceV2(mtrSystemService.calculateMtrSystemsToIntegrate, dto).then(
				function (mtrSystemsToIntegrate) {
					const mtrSystems = [];
					$scope.exemptionMessages = [];

					for (const index in mtrSystemsToIntegrate) {
						const item = mtrSystemsToIntegrate[index];
						const sourceId = item.source.id;

						if (item.exemptionMessage) {
							$scope.exemptionMessages.push({
								message: item.exemptionMessage,
								status: Vgr.constants.generalStatus.warning
							});
						}

						mtrSystems.push({
							SourceId: sourceId,
							SourceDescription: item.source.description,
							HasToGenerateMtr: item.hasToGenerateMtr,
							Selected: true
						});
					}

					deferred.resolve(mtrSystems);
				},
				function () {
					deferred.resolve([]);
				}
			);

			return deferred.promise;
		}

		function getDisposalResidueIds() {
			const residues = $scope.ctrl.destinationModel.Residues || [];
			return [...new Set(residues.map((r) => r.ResidueGuidId).filter((id) => !!id))];
		}

		function updateSlip() {
			if (hasAnyExternalSystemChecked()) {
				$scope.updateSlip($scope.stepsEnum.D, getSlipDescription());
			} else {
				$scope.updateSlip($scope.stepsEnum.D, null);
			}
		}

		function hasAnyExternalSystemChecked() {
			return $scope.ctrl.destinationModel.ExternalSystems &&
				$scope.ctrl.destinationModel.ExternalSystems.find((system) => system.Selected && system.HasToGenerateMtr)
				? true
				: false;
		}

		function getSlipDescription() {
			let slipDescription = "";
			const externalSystems = $scope.ctrl.destinationModel.ExternalSystems;

			for (const i in externalSystems) {
				if (externalSystems[i].Selected && externalSystems[i].HasToGenerateMtr) {
					slipDescription += externalSystems[i].SourceDescription + "\n";
				}
			}

			return slipDescription;
		}

		$scope.systemChange = function () {
			updateSlip();
			$rootScope.$broadcast(Vgr.constants.evtClientExternalSystemChanged, $scope.ctrl.destinationModel.Id);
		};
	}
]);
